module.exports = __webpack_public_path__ + "media/images/admin/icons/photo_camera_white-e7bd2076ecdfc824fe635af494325835.png";